
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import { Credential } from "@/models/common";
import Swal from "sweetalert2";

@Component({})
export default class UpdateCredentialComponent extends Vue {
  public credential = new Credential();
  public newpasswordFieldType = "password";
  public confirmpasswordFieldType = "password";
  public currentpasswordFieldType = "password";
  public showErrorMessage = null;
  public credentialUpdateOTPMatched = false;
  public showCredentialPage = false;
  public noButtonEnabled = false;
  public yesButtonEnabled = true;
  public disableSubmitbutton = false;

  get user() {
    return this.$store.state.user;
  }
  public async verifyOPTToUpdateCredential(value, otp) {
    if (value && value != "" && otp) {
      this.$showLoader(true);
      const response = await Axios.post(
        API_STORE.AUTHENTICATION + "verifyOPTToValidateCredential",
        { type: "phone", value: value, otp },
        { headers: getAPIAuthorizedHeader() }
      );
      this.$showLoader(false);
      if (response) {
        this.credentialUpdateOTPMatched = true;
        Swal.fire({
          position: "center",
          icon: "success",
          title: "OTP matched successfully",
          showConfirmButton: true,
        });
      } else this.credentialUpdateOTPMatched = false;
    }
  }

  public async resendOPTToVerifyCredential(value, resend) {
    if (value) {
      this.$showLoader(true);
      const response = await Axios.post(
        API_STORE.AUTHENTICATION + "sentOPTToVerifyCredential",
        { type: "phone", value: value, retry: resend },
        { headers: getAPIAuthorizedHeader() }
      );

      this.$showLoader(false);
      if (response) {
        await this.$store.dispatch("updateStore", {
          phoneOTPSent: true,
        });
        Swal.fire({
          position: "center",
          icon: "success",
          title: resend
            ? "OTP has been resend successfully"
            : "OTP has been send successfully",
          showConfirmButton: true,
        });
      }
    }
  }
  public async validateAndSave() {
    let result = await this.$validator.validateAll("passwordChanged");
    if (
      result &&
      this.credential.newPassword == this.credential.confirmPassword &&
      this.credentialUpdateOTPMatched
    ) {
      if (result && this.credential.changeCredential) {
        this.disableSubmitbutton = true;
        let response = await Axios.post(
          API_STORE.AUTHENTICATION + "updatePassword",
          {
            userId: this.$route.query.userId,
            newPassword: this.credential.newPassword,
          },
          {
            headers: getAPIAuthorizedHeader(),
          }
        );
        this.disableSubmitbutton = false;
        if (response) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: true,
          });
          if (this.showCredentialPage) {
            this.$router.push(
              this.$route.path == "/superAdmin/credentials"
                ? "/superAdmin"
                : "/portal"
            );
          } else this.$emit("updateCredential", true);
        }
      }
    }
  }

  public updateToNextTab() {
    this.$emit("updateCredential", true);
  }

  public saveInformation() {
    return { status: true };
  }
  public cancel() {
    this.$router.push(
      this.$route.path == "/superAdmin/credentials" ? "/superAdmin" : "/portal"
    );
  }

  public switchVisibility(fieldType) {
    this[fieldType] = this[fieldType] === "password" ? "text" : "password";
  }
  async mounted() {
    if (
      this.$route.path == "/superAdmin/credentials" ||
      this.$route.path == "/portal/credentials"
    ) {
      await this.$store.dispatch("getUserById", {
        userId: this.$route.query.userId,
      });
      this.showCredentialPage = true;
    }
  }
}
